import * as React from 'react';
import clsx from 'clsx';

import { ISharedComponentProps } from './shared-props';

/* eslint-disable-next-line */
export interface ILinkButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, ISharedComponentProps {}

export const LinkButton = ({
    icon: Icon,
    label,
    active = false,
    className,
    colorIcon = true,
    ...rest
}: ILinkButtonProps) => {
    const renderLabel = () => {
        if (label) {
            return (
                <div className='component-label'>
                    {label}
                </div>
            );
        } else {
            return null;
        }
    };

    const renderIcon = () => {
        if (Icon) {
            return (
                <div className='component-icon'>
                    {React.cloneElement(Icon, {
                        className: clsx(Icon.props.className, 'interactable-icon')
                    })}
                </div>
            );
        } else {
            return null;
        }
    };

    return (
        <button
            type='button'
            className={clsx('interactable-icon-wrapper', className, {
                'active': active,
                'no-label': !label,
                'no-icon': !Icon,
                'color-icon': colorIcon
            })}
            {...rest}
        >
            {renderIcon()}
            {renderLabel()}
        </button>
    );
};
